<template>
  <div class="main-content super-admin-dashboard">
    <!-- Stats Overview Skeleton -->
    <div class="dashboard-stats-section">
      <div class="section-header">
        <div class="skeleton-box" style="height: 28px; width: 200px;"></div>
      </div>
      <div class="stats-grid">
        <!-- Stat Cards Skeletons -->
        <div v-for="n in 3" :key="n" class="stat-card">
          <div class="stat-icon">
            <div class="skeleton-box" style="height: 40px; width: 40px; border-radius: 50%;"></div>
          </div>
          <div class="stat-content">
            <div class="skeleton-box mb-2" style="height: 32px; width: 80px;"></div>
            <div class="skeleton-box mb-2" style="height: 18px; width: 120px;"></div>
            <div class="skeleton-box" style="height: 14px; width: 140px;"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Actions Skeleton -->
    <div class="quick-actions-section">
      <div class="section-header">
        <div class="skeleton-box" style="height: 28px; width: 150px;"></div>
      </div>
      <div class="quick-actions-grid">
        <div v-for="n in 3" :key="n" class="quick-action-skeleton">
          <div class="skeleton-box" style="height: 24px; width: 24px; border-radius: 50%; margin-bottom: 8px;"></div>
          <div class="skeleton-box" style="height: 16px; width: 100px;"></div>
        </div>
      </div>
    </div>

    <!-- Table Skeleton -->
    <div class="dashboard-card branches-table-section">
      <div class="card-header-modern">
        <div class="skeleton-box" style="height: 24px; width: 180px;"></div>
      </div>
      <div class="table-responsive p-3">
        <table class="table modern-table">
          <thead>
            <tr>
              <th v-for="n in 7" :key="n">
                <div class="skeleton-box" style="height: 18px; width: 80%;"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in 5" :key="row">
              <td v-for="col in 7" :key="col">
                <div class="skeleton-box" :style="`height: 16px; width: ${getRandomWidth()}%;`"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Admissions Cards Skeleton -->
    <div class="dashboard-card admissions-section">
      <div class="card-header-modern d-flex justify-content-between align-items-center">
        <div class="skeleton-box" style="height: 24px; width: 200px;"></div>
        <div class="d-flex gap-2">
          <div class="skeleton-box" style="height: 38px; width: 150px;"></div>
          <div class="skeleton-box" style="height: 38px; width: 150px;"></div>
        </div>
      </div>
      <div class="admissions-grid p-3">
        <div v-for="n in 4" :key="n" class="admission-card-skeleton">
          <div class="skeleton-box" style="height: 60px; width: 60px; border-radius: 50%; margin: 0 auto 16px;"></div>
          <div class="skeleton-box" style="height: 32px; width: 60px; margin: 0 auto 8px;"></div>
          <div class="skeleton-box" style="height: 16px; width: 100px; margin: 0 auto;"></div>
        </div>
      </div>
    </div>

    <!-- Charts Skeleton -->
    <div class="charts-container">
      <div class="charts-row">
        <div v-for="n in 2" :key="n" class="chart-container bg-white">
          <div class="admin-head p-3">
            <div class="skeleton-box" style="height: 24px; width: 120px;"></div>
          </div>
          <div class="p-3">
            <div class="d-flex gap-2 mb-3">
              <div class="skeleton-box" style="height: 38px; width: 150px;"></div>
              <div class="skeleton-box" style="height: 38px; width: 150px;"></div>
            </div>
            <div class="skeleton-box" style="height: 320px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardSkeleton",
  methods: {
    getRandomWidth() {
      return Math.floor(Math.random() * 45) + 50;
    },
  },
};
</script>

<style scoped>
/* Main Container */
.main-content.super-admin-dashboard {
  padding: 20px;
}

/* Skeleton Animation */
.skeleton-box {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Stats Section */
.dashboard-stats-section {
  margin-bottom: 30px;
}

.section-header {
  margin-bottom: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.stat-icon {
  flex-shrink: 0;
}

.stat-content {
  flex: 1;
}

/* Quick Actions */
.quick-actions-section {
  margin-bottom: 30px;
}

.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.quick-action-skeleton {
  padding: 20px;
  border-radius: 12px;
  background: white;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

/* Dashboard Cards */
.dashboard-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 24px;
  overflow: hidden;
}

.card-header-modern {
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.table-responsive {
  overflow-x: auto;
}

.table {
  width: 100%;
  margin-bottom: 0;
}

.table thead th {
  padding: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.table tbody td {
  padding: 12px;
  border-bottom: 1px solid #f3f4f6;
}

/* Admissions Section */
.admissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.admission-card-skeleton {
  padding: 24px;
  border-radius: 12px;
  background: #f9fafb;
  text-align: center;
}

/* Charts */
.charts-container {
  margin-top: 24px;
}

.charts-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 24px;
}

.chart-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}

.admin-head {
  border-bottom: 1px solid #e5e7eb;
}

/* Utilities */
.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.gap-2 {
  gap: 0.5rem;
}

.p-3 {
  padding: 1rem;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.bg-white {
  background-color: white;
}

/* RTL Support for Arabic */
[dir="rtl"] .stat-card {
  flex-direction: row-reverse;
}

[dir="rtl"] .table {
  text-align: right;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .skeleton-box {
    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
    background-size: 200% 100%;
  }
  
  .stat-card,
  .quick-action-skeleton,
  .dashboard-card,
  .chart-container {
    background: #1f2937;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  }
  
  .admission-card-skeleton {
    background: #374151;
  }
  
  .card-header-modern,
  .admin-head {
    border-bottom-color: #374151;
  }
  
  .table thead th {
    border-bottom-color: #374151;
  }
  
  .table tbody td {
    border-bottom-color: #1f2937;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .quick-actions-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
  
  .charts-row {
    grid-template-columns: 1fr;
  }
  
  .admissions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .admissions-grid {
    grid-template-columns: 1fr;
  }
}
</style>
